import { CSSProperties } from "react";
import { styled } from "styled-components";

export const StyledVideoPreview = styled.div<{
  $mirrored?: boolean,
  $enabled?: boolean,
  $objectFit: CSSProperties['objectFit'],
}>`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  line-height: 1;
  border-radius: var(--radius-xl);
  background-color: var(--color-video-bg);
  video {
    width: 100%;
    height: 100%;
    object-fit: ${({ $objectFit }) => $objectFit};
    transform: ${({ $mirrored }) => ($mirrored ? 'scaleX(-1)' : 'none')};
  }

  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: var(--font-size-lg);
    color: var(--color-white);
    padding: var(--spacing-md) var(--spacing-md);
    white-space: nowrap;
  }
`;
